import { render, staticRenderFns } from "./RbContentModules.vue?vue&type=template&id=ec348c36&"
import script from "./RbContentModules.vue?vue&type=script&lang=js&"
export * from "./RbContentModules.vue?vue&type=script&lang=js&"
import style0 from "./RbContentModules.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports